import type { ImageSizeKeysTypes } from '@axiom/const';
import { CandidateImageConst } from '@axiom/const';
import type { Candidate } from '@axiom/validation';

import { DesignSysEnvUtil } from './design-sys-env-util';

const {
  IMAGE_RESIZE_DIRECTORY,
  ImageSizesByWidth,
  ImageSizesByHeight,
  PROFILE_IMAGE_DIRECTORY,
} = CandidateImageConst;

export const CandidateProfileUtil = {
  getProfileImageUri(
    candidate: Pick<Candidate, 'profileImageKey'>,
    size: ImageSizeKeysTypes | null
  ) {
    const { profileImageKey } = candidate;

    if (
      !profileImageKey ||
      !size ||
      !(!(size in ImageSizesByWidth) || !(size in ImageSizesByHeight)) ||
      !DesignSysEnvUtil.publicS3Bucket
    ) {
      return null;
    }

    const [idSlug] = profileImageKey
      .replace(`${PROFILE_IMAGE_DIRECTORY}/`, '')
      .split('/');
    const { width, height } =
      size in ImageSizesByWidth
        ? ImageSizesByWidth[size]
        : ImageSizesByHeight[size];

    return `${DesignSysEnvUtil.publicBaseUrlS3}/${DesignSysEnvUtil.publicS3Bucket}/${IMAGE_RESIZE_DIRECTORY}/${idSlug}/${width}x${height}`;
  },
};
